const UserList = () => import('@/pages/user-manage/UserList');
const UserDetail = () => import('@/pages/user-manage/UserDetail');


export default[
    {
      path: '/user-list',
      component: UserList,
      meta: [
        {
          name: '用户管理',
          url: '/user-list',
        },
        {
          name: '用户列表',
          url: '/user-list',
        },
      ],
    },
    {
      path: '/user-list/user-detail',
      component: UserDetail,
      meta: [
        {
          name: '用户管理',
          url: '/user-list',
        },
        {
          name: '用户列表',
          url: '/user-list',
        },
        {
          name: '用户详情',
          url: '',
        },
      ],
    },
]
